import http from "../http-common";

const agent_sessions = ({ token, initDate, endDate }) => {
  return http.get(
    `/api/v1/bauhaus/agent_sessions?initTime=${initDate}&endTime=${endDate}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const calls_by_events = ({ token, initDate, endDate }) => {
  return http.get(
    `/api/v1/bauhaus/calls_by_events?initTime=${initDate}&endTime=${endDate}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const spy_call = ({ token, data }) => {
  return http.post(`/api/v1/bauhaus/spy_call`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const global_stats = ({ token, startDate, endDate }) => {
  return http.get(
    `/api/v1/bauhaus/global_stats?startDate=${startDate}&endDate=${endDate}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const status = ({ token, data }) => {
  return http.post(`/api/v1/realtime/status`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const call_by_id = ({ token, callId }) => {
  return http.get(`/api/v1/bauhaus/call/${encodeURIComponent(callId)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const call_by_id_outbound = ({ token, callId }) => {
  return http.get(`/api/v1/bauhaus/call/${encodeURIComponent(callId)}/outbound`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const export_008q_csv = ({ token, startDate, endDate, company }) => {
  const params = new URLSearchParams();
  params.set("startDate", startDate);
  params.set("endDate", endDate);
  if (company) params.set("company", company);

  return http.get(`/api/v1/bauhaus/008q/export_csv?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
};

export default {
  agent_sessions,
  calls_by_events,
  spy_call,
  global_stats,
  status,
  call_by_id,
  call_by_id_outbound,
  export_008q_csv,
};